import './ProfileImageForm.scss'
import Loader from '../../../../widgets/Generic/Loader'
import React from 'react'
import Toast from '../../../Toastr/Toast'
import translate from '../../../../utilities/translate'
import translations from './translations'
import Form from '../../../../widgets/Form'
import ImageInput from '../../../../widgets/Form/ImageInput/ImageInput'

// trans :: String -> String -> String
const trans = translate(translations)

export default ({
  updateImage,
  error,
  locale,
  uploaded,
  uploading,
  user,
}) =>
  <div className="image-edition-wrapper">
    <Form onSubmit={ () => {} }>
      <div className="image-edition-input-wrapper">
        { uploading
          ? <div className="loader-wrapper"><Loader /></div>
          : null
        }
        <ImageInput
          name="image-input"
          aria-label={ trans(locale)('changeImage') }
          onChange={ updateImage }
          disabled={ uploading }
          value={ user.image }
        />
      </div>
    </Form>
    { error ? <Toast message={ trans(locale)('error') } level="error" /> : null }
    { uploaded ? <Toast message={ trans(locale)('uploaded') } level="success" /> : null }
  </div>
